import React from 'react'
import { ArrowBackIosOutlinedIcon } from '../utils/constants/icons'

export const DownArrowIcon = () => {
  return (
    <>
      <ArrowBackIosOutlinedIcon className="down-arrow-icon"/>
    </>
  )
}

